import styled from 'styled-components';
import { Text } from '@zillow/constellation';

export const StyledPostingPathAdminText = styled(Text)<{ isImpersonator: boolean }>`
  color: ${(props) => (props.isImpersonator ? 'red' : '#0c4499')};
  padding-right: 6px;
`;

export const StyledWrapper = styled.div<{ isImpersonator: boolean }>`
  height: 38px;
`;
StyledWrapper.displayName = 'StyledWrapper';

export const StyledFixedAdminBar = styled.div<{ isImpersonator: boolean }>`
  background-color: ${(props) => (props.isImpersonator ? '#ffcccc' : '#dbdbdb')};
  border-bottom: ${(props) => (props.isImpersonator ? '2px dashed red' : '2px dashed  #0c4499')};
  padding: 6px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;
